import moment from "moment";
import AuthLayout from "../../../components/layouts/auth";
import { numberWithCommas } from "../../../lib/helper-support";
import TablePagination from "../../../components/table/table-pagination";
import { useState } from "react";
import { useMarketing } from "../../../composables/marketing/useMarketing";
import SearchInput from "../../../components/form/search-input";
import TableSkeleton from "../../../components/loader/table-placeholder-loader";
import { Link } from "react-router-dom";
import Button from "../../../components/form/button";
import { MarketingCampaignProps } from "../../../types/MarketingCampaignProps";
import MarketingStatusBadge from "./status-badge";

const Marketing = () => {
  const [page, setCurrentPage] = useState<number>(1);

  const [search, setSearch] = useState<string>("");

  const { data, isLoading } = useMarketing({
    page,
    search,
  });

  return (
    <AuthLayout>
      <div>
        <div className="items-center space-y-5 lg:justify-between lg:flex md:flex md:space-y-0">
          <div className="flex items-center gap-2 md:gap-6 flex-wrap">
            <h1 className="page-title">Marketing Campaign</h1>
            <span className="text-tertiary font-[600] text-[14px]">
              {numberWithCommas(data?.total || 0)} marketing campaigns
            </span>
          </div>
        </div>

        <div className="relative">
          <div className="items-center mt-5 lg:justify-between lg:flex">
            <SearchInput
              placeholder="Find campaign"
              value={search}
              onChangeInput={(e) => setSearch(e.target.value)}
            />
            <div>
              <Link to={"/marketing/create"} className="btn btn-primary">
                <Button text="Create Campaign" />
              </Link>
            </div>
          </div>
          {/* table */}
          <div className="relative overflow-x-auto">
            <table className="mt-10 text-tertiary font-[600] text-[14px] w-full relative z-10 whitespace-nowrap">
              <thead>
                <tr className="border-b border-[#E6EAF0]">
                  <td className="px-2 py-3">
                    {/* <input type='checkbox' /> */}#
                  </td>
                  <td className="px-6 py-3">Campaign Name</td>
                  <td className="px-6 py-3">Status</td>
                  <td className="px-6 py-3">Scheduled At</td>
                  <td className="px-6 py-3">Sent</td>
                  <td className="px-6 py-3">Date Created</td>
                </tr>
              </thead>
              <tbody className="relative">
                {isLoading && <TableSkeleton numberOfColumns={8} />}
                {!isLoading &&
                  data?.items?.map(
                    (item: MarketingCampaignProps, index: number) => (
                      <tr
                        key={item.uuid}
                        className="border-b border-[#E6EAF0] relative"
                      >
                        <td className="px-2 py-3">
                          {index + 1}
                          <Link
                            to={`/marketing/${item.uuid}`}
                            className="absolute top-0 bottom-0 left-0 w-full h-full hover:bg-[#E6EAF0] opacity-[0.2]"
                          />
                        </td>
                        <td className="px-4 py-3">{item.title}</td>
                        <td className="px-4 py-3"><MarketingStatusBadge status={item.status}/></td>
                        <td className="px-4 py-3">
                          {item.scheduled_at
                            ? moment(item.scheduled_at).format("MMM D, YYYY")
                            : "-"}
                        </td>
                        <td className="px-4 py-3">
                          {item.sent_count}/{item.total_recipients}
                        </td>
                        <td className="px-4 py-3">
                          {moment(item.created_at).format("MMM D, YYYY")}
                        </td>
                      </tr>
                    ),
                  )}
              </tbody>
            </table>
          </div>
          {/*--/ table */}
          {/* pagination */}
          {!isLoading && (
            <div className="mt-5">
              <TablePagination
                totalPages={data?.totalPages ?? 0}
                onPageChange={(page) => setCurrentPage(page)}
                currentPage={data?.page}
              />
            </div>
          )}
          {/* --/ pagination */}
        </div>
      </div>
    </AuthLayout>
  );
};

export default Marketing;
